import classnames from 'classnames';
import { getRelativeTime } from 'helper/time';
import type React from 'react';
import { useRef } from 'react';

import { ConnectivityState, Severity } from 'API';

import './_styles.scss';

import { useClock } from 'hooks/useClock';

interface Props {
    severity?: Severity;
    relativeTime?: string;
    vehicleIdentifier: string;
    isSelected?: boolean;
    className?: string;
    onClick?: () => void;
    icon?: React.ReactNode;
    connectivityState?: ConnectivityState | null;
}

const VehicleCard = ({
    className,
    onClick,
    severity,
    relativeTime,
    vehicleIdentifier,
    icon,
    isSelected,
    connectivityState,
}: Props) => {
    const elementRef = useRef<HTMLDivElement>(null);
    const datetime = useClock();

    return (
        <div
            className={classnames(`VehicleCard ${className ?? ''}`, {
                'VehicleCard--active': isSelected,
                'VehicleCard--fatal': severity === Severity.FATAL,
                'VehicleCard--error': severity === Severity.ERROR,
                'VehicleCard--warning': severity === Severity.WARNING,
                'VehicleCard--stable':
                    !severity ||
                    (severity !== Severity.FATAL && severity !== Severity.ERROR && severity !== Severity.WARNING),
            })}
            onClick={onClick}
        >
            <div
                ref={elementRef}
                className='VehicleCard__innerCard'
                data-testid={`vehicle-deviation-card-${vehicleIdentifier.toLowerCase()}`}
            >
                {icon}
                <p className='VehicleCard__datetime'>
                    {relativeTime ? `Since ${getRelativeTime(datetime, new Date(relativeTime))}` : 'Unknown'}
                </p>
                <p className='VehicleCard__identifier'>
                    <span className='VehicleCard__identifierText'>{vehicleIdentifier}</span>
                    <span
                        data-testid='vehicle-connectivity-icon'
                        className={classnames('VehicleCard__wifi rioglyph', {
                            'rioglyph-wifi VehicleCard__wifi--online': connectivityState === ConnectivityState.ONLINE,
                            'rioglyph-wifi-off VehicleCard__wifi--offline':
                                connectivityState !== ConnectivityState.ONLINE,
                        })}
                    />
                </p>
            </div>
        </div>
    );
};

export default VehicleCard;
